module.exports = __webpack_public_path__ + "static/media/caret-up-disable.ae7eb291.svg";